<template>
  <UserCommonLayout :main-class-name="'pt0'">
    <template #content>
      <LazyProSkillAssureSettingsCreateBreadCrumb />
      <LazyProSkillAssureSettingsCommonHeader :create-step="createStep" />
      <LazyProSkillAssureSettingsCommonContent v-model:create-step="createStep" />
    </template>
  </UserCommonLayout>
</template>

<script setup lang="ts">
import {
  LazyProSkillAssureSettingsCommonContent,
  LazyProSkillAssureSettingsCommonHeader,
  LazyProSkillAssureSettingsCreateBreadCrumb,
  UserCommonLayout
} from '#components';
import {useLoadingStore} from '~/store/loading/loadingStore';
import {useUserStore} from '~/store/user/userStore';
import {ProSkillAssureCreateStepType} from '~~/package/mapper/proSkillAssure/model/ProSkillAssureCreateStepType';
import {useGenericDialog} from '~/composables/useGenericDialog';
import {SubscriptionStatus} from '~~/package/mapper/subscription/model/SubscriptionStatusType';

const loadingStore = useLoadingStore();
const userStore = useUserStore();
const {
  openSkillCertifySubscriptionNullAlert,
  openSkillCertifySubscriptionExpireAlert
} = useGenericDialog();
const { guard } = usePermissionGuard();
const router = useRouter();

// ASMT-AUTH-01: 3-step 평가 생성 마법사(ASSESSMENT_SET → BASIC_INFO → PROCTORING), 단계는 URL ?step= 와 동기화
const createStep = ref(ProSkillAssureCreateStepType.ASSESSMENT_SET);

const handlerAssessmentMenuDoNotHavePermission = (): boolean => {
  return guard(
    userStore.isPermissionCreateAssessment || userStore.isSuperAdminType,
    { redirectTo: { name: "dashboard" } }
  );
};

const waitForAuthResolved = (): Promise<void> => {
  if (userStore.isAuthResolved) return Promise.resolve();
  return new Promise<void>((resolve) => {
    const stop = watch(
      () => userStore.isAuthResolved,
      (resolved) => {
        if (resolved) {
          stop();
          resolve();
        }
      }
    );
  });
};

onMounted(async () => {
  if (!handlerAssessmentMenuDoNotHavePermission()) return;

  await waitForAuthResolved();

  loadingStore.closeLoading();

  // router.replace를 먼저 await → beforeEach의 closePopups() 실행 완료 후 alert 열기
  await router.replace({ query: { step: createStep.value.toString() } });

  if (!userStore.subscription) {
    openSkillCertifySubscriptionNullAlert();
    return;
  }

  if (userStore.subscription.status === SubscriptionStatus.INACTIVE) {
    openSkillCertifySubscriptionExpireAlert();
  }
});

watch(createStep, (step: ProSkillAssureCreateStepType) => {
  router.replace({
    query: { step: step.toString() }
  });
});
</script>

<style>
@import "~/assets/scss/business_style.scss";
</style>
